/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjYyOTk5NyAxLjg1OTk5SDE1LjM4VjIuODU5OTlIMC42Mjk5OTdWMS44NTk5OVpNMy45NyA3LjQ5OTk5SDEyLjAyVjguNDk5OTlIMy45N1Y3LjQ5OTk5Wk05LjkxIDEzLjE0SDYuMDlWMTQuMTRIOS45MVYxMy4xNFoiIGZpbGw9ImluaGVyaXQiLz4=";